<template>
  <div class="filter-menu">
    <div class="filter-header">
      <span>Filter Submissions</span>
    </div>
    <div class="filter-body">
      <!-- Statuses -->
      <div class="list-item list-item-header">
        <span>Statuses</span>
      </div>
      <div class="list-item" v-for="status of statuses" :key="status">
        <div className="filter-checkbox-container" :data-checked="isStatusSelected(status)"
          @click=toggleStatusSelected(status)>
          <label className="filter-checkbox-icon"></label>
        </div>
        <span>{{ status }}</span>
      </div>
      <!-- Forms -->
      <div class="list-item list-item-header">
        <span>Forms</span>
      </div>
      <div class="list-item" v-for="form of store.forms" :key="form.id">
        <div className="filter-checkbox-container" :data-checked="isFormSelected(form.id)"
          @click=toggleFormSelected(form.id)>
          <label className="filter-checkbox-icon"></label>
        </div>
        <span>{{ form.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { store, fetchAccountForms } from '../../api'

export default {
  name: 'FilterMenu',
  data() {
    return {
      store,
      statuses: ['Ready to Import', 'Imported', 'Shared'],
    }
  },
  created() {
    fetchAccountForms();
  },
  methods: {
    toggleFormSelected(id) {
      if (store.filterSelectedForms.has(id)) {
        store.filterSelectedForms.delete(id);
      } else {
        store.filterSelectedForms.add(id);
      }

      this.$emit('onFilterChanged');
    },
    toggleStatusSelected(status) {
      if (store.filterSelectedStatuses.has(status)) {
        store.filterSelectedStatuses.delete(status);
      } else {
        store.filterSelectedStatuses.add(status);
      }

      this.$emit('onFilterChanged');
    },
    isFormSelected(id) {
      return store.filterSelectedForms.has(id);
    },
    isStatusSelected(status) {
      return store.filterSelectedStatuses.has(status)
    }
  },
  emits: ['onFilterChanged']
}
</script>

<style scoped>
.filter-menu {
  position: absolute;
  right: calc(100% + 10px);
  top: -10px;
  width: 300px;
  background: #FFF;
  box-shadow: 0px 2px 8px #00000033;
  border-radius: 10px;
  z-index: 10;
  overflow: hidden;
}

.filter-header {
  padding: 15px;
  font-weight: bold;
  background: #FAFAFA;
  box-shadow: 0px 2px 4px #00000011;
}

.filter-body {
  padding: 8px;
  overflow-y: auto;
  max-height: 400px;
}

.list-item {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 7px;
  border-bottom: 1px solid #EEE;
}

.list-item span {
  flex: 1;
  width: 1px;
  display: block;
  text-wrap: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
}

.filter-checkbox-container {
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 0.5px solid #CCC;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer !important;
  flex-shrink: 0;
  vertical-align: middle;
  border-radius: 5px;
}

.filter-checkbox-container:hover {
  background-color: #EEE;
}

.filter-checkbox-container[data-checked="true"] {
  background-color: var(--color-primary);
}

.filter-checkbox-container[data-checked="true"] .filter-checkbox-icon {
  position: absolute;
  margin: 0;
  right: 13px;
  bottom: 6px;
  width: 6px;
  height: 12px;
  transform-origin: bottom right;
  border-right: 2.5px solid #FFF;
  border-bottom: 2.5px solid #FFF;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  cursor: pointer;
}
</style>